// extracted by mini-css-extract-plugin
module.exports = {"genericSection":"Travel_genericSection__HEfZS","landingWrap":"Travel_landingWrap__Pd6__"};